import Vue from "vue";
import VueRouter from "vue-router";

import configurations from "commons/configurations";
import { AUTH_NAMESPACE, USER } from "store/modules/auth.js";
import PreLoginLayout from '~/views/pre-login/BasePreLogin.vue'

Vue.use(VueRouter);

// Rota utilizada apenas se o sistema estiver em manutenção
const routesManutencao = [
  {
    path: "*",
    name: "manutencao",
    component: () => import("~/views/ManutencaoView.vue"),
    meta: { title: configurations.app.name },
  },
]
// Todas as Rotas do sistema, ao criar uma nova rota, verificar se necessita da metatag 'breadcrumb'
const routes = [
  {
    path: "*",
    name: "not-found",
    component: () => import(/* webpackChunkName: "not-found" */ "~/views/404View.vue"),
    meta: {
      title: configurations.app.name
    },
  },
  {
    path: '/',
    name: 'landingpage',
    component: () => import(/* webpackChunkName: "landingpage" */ '~/views/pre-login/BaseLandingPage.vue'),
  },
  {
    path: '/',
    component: PreLoginLayout,
    children: [
      {
        path: "/login",
        component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/Login.vue"),
        meta: {
          title: "Entrar"
        },
      },
    ],
  },
  {
    path: "/recuperar-senha",
    name: "Recuperar Senha",
    component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/RecuperarSenha.vue"),
  },
  {
    path: "/primeiro-acesso/:cpf/:token",
    name: "Primeiro Acesso",
    component: () => import( /* webpackChunkName: "pre-login" */ "views/pre-login/PrimeiroAcesso.vue"),
  },
  {
    path: "/app",
    component: () => import("views/post-login/BasePostLogin.vue"),
    meta: {
      requiresAuth: true,
      title: "Início",
    },
    children: [
      {
        path: "/",
        component: () => import( /* webpackChunkName: "post-login" */ "views/post-login/Welcome.vue"),
        meta: {
          title: "Início",
        },
      },
      {
        path: "consultar-notificacoes",
        component: () => import( /* webpackChunkName: "post-login" */ "views/post-login/participante/ListarNotificacoes.vue"),
        meta: {
          title: "Consultar Notificações",
          breadcrumb: "Consultar Notificações",
        },
      },
      {
        path: '/consentimento-uso-de-dados-pessoais',
        component: () =>
          import(
            /* webpackChunkName: "termo" */ '~/views/post-login/administrador/termo-lgpd/TermoLGPD.vue'
          ),
        meta: {
          title: 'Consentimento de Uso de Dados Pessoais',
          breadcrumb: 'Consentimento de Uso de Dados Pessoais',
        },
      },
      {
        path: '/trocar-senha',
        component: () =>
          import(
            /* webpackChunkName: "termo" */ '~/views/post-login/TrocarSenha.vue'
          ),
        meta: {
          title: 'Definir nova senha',
          breadcrumb: 'Definir nova senha',
        },
      },
      {
        path: '/atualizacao-cadastral-primeiro-acesso',
        component: () =>
          import(
            /* webpackChunkName: "atualizacaoCadastralPrimeiroAcesso" */ '~/views/post-login/administrador/manter-atualizacao-cadastral-primeiro-acesso/AtualizacaoCadastralPrimeiroAcesso.vue'
          ),
        meta: {
          title: 'Atualização Cadastral Primeiro Acesso',
          breadcrumb: 'Atualização Cadastral Primeiro Acesso',
        },
      },
      {
        path: 'usuario/atualizacao-cadastral',
        component: () =>
          import(
            /* webpackChunkName: "atualizacaoCadastral" */ '~/views/post-login/administrador/manter-atualizacao-cadastral/ManterAtualizacaoCadastralView.vue'
          ),
        meta: {
          title: 'Atualizar Cadastro',
          breadcrumb: 'Atualizar Cadastro',
        },
      },
      {
        path: 'aba/gerenciar-aba',
        name: 'Gerenciar Aba',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-aba/ManterAbasView.vue'),
        meta: {
          title: 'Gerenciar Aba',
          breadcrumb: "Administrador/Gerenciar Abas",
        },
      },
      {
        path: 'ata/gerenciar-ata',
        name: 'Gerenciar Ata',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-ata/ManterAtasView.vue'),
        meta: {
          title: 'Gerenciar Ata',
          breadcrumb: "Administrador/Gerenciar Ata",
        },
      },
      {
        path: 'formacoes/aprovar-ata',
        name: 'Aprovar Ata',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-ata/AprovarAtaView.vue'),
        meta: {
          title: 'Aprovar Ata',
          breadcrumb: "Formações/Aprovar Ata",
        },
      },
      {
        path: 'perfil/gerenciar-perfil',
        name: 'Gerenciar Perfil',
        component: () => import( /* webpackChunkName: "admin" */ 'views/post-login/administrador/manter-perfis/ManterPerfisView.vue'),
        meta: {
          title: 'Gerenciar Perfil',
          breadcrumb: "Administrador/Gerenciar Perfis",
        },
      },
      {
        path: 'termo/gerenciar-termo',
        name: 'Gerenciar Termo',
        component: () => import( /* webpackChunkName: "admin" */ 'views/post-login/administrador/manter-termo/ManterTermoView.vue'),
        meta: {
          title: 'Gerenciar Termo',
          breadcrumb: "Administrador/Gerenciar Termos",
        },
      },
      {
        path: 'funcao/gerenciar-funcao',
        name: 'Gerenciar Função',
        component: () => import( /* webpackChunkName: "admin" */ 'views/post-login/administrador/manter-funcao/ManterFuncoesView.vue'),
        meta: {
          title: 'Gerenciar Função',
          breadcrumb: "Administrador/Gerenciar Funções",
        },
      },
      {
        path: 'grupo/gerenciar-grupo',
        name: 'Gerenciar Grupo',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-grupo/ManterGrupoView.vue'),
        meta: {
          title: 'Gerenciar Grupo',
          breadcrumb: "Administrador/Gerenciar Grupo",
        },
      },
      {
        path: 'grupo-notificacao/gerenciar-grupo-notificacao',
        name: 'Gerenciar Notificações',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-grupo-notificacao/ManterGrupoNotificacaoView.vue'),
        meta: {
          title: 'Gerenciar Notificações',
          breadcrumb: "Cadastro/Gerenciar Notificações",
        },
      },
      {
        path: 'usuario/gerenciar-usuario',
        name: 'Gerenciar Usuário',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-usuario/ManterUsuarioView.vue'),
        meta: {
          title: 'Gerenciar Usuário',
          breadcrumb: "Administrador/Gerenciar Usuário",
        },
      },
      {
        path: 'setor/gerenciar-setor',
        name: 'Gerenciar Setor',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-setor/ManterSetoresView.vue'),
        meta: {
          title: 'Gerenciar Setor',
          breadcrumb: "Cadastro/Gerenciar Setor",
        },
      },
      {
        path: 'faq/gerenciar-faq',
        name: 'Gerenciar Faq',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-faq/ManterFaqsView.vue'),
        meta: {
          title: 'Gerenciar Faq',
          breadcrumb: "Cadastro/Gerenciar Faq",
        },
      },
      {
        path: 'disciplina/gerenciar-disciplina',
        name: 'Gerenciar Disciplina',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-disciplina/ManterDisciplinaView.vue'),
        meta: {
          title: 'Gerenciar Disciplina',
          breadcrumb: "Cadastro/Gerenciar Disciplina",
        },
      },
      {
        path: 'formacoes/gerenciar-formacoes',
        name: 'Gerenciar Formações',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-formacoes/ManterFormacoesView.vue'),
        meta: {
          title: 'Gerenciar Formações',
          breadcrumb: "Formações/Gerenciar Formações",
        },
      },
      {
        path: 'formacoes/aprovar-solicitacao-formacoes',
        name: 'Aprovar Formações',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-formacoes/ManterAprovacaoSolicitacaoView.vue'),
        meta: {
          title: 'Aprovar Solicitações de Formação',
          breadcrumb: "Formações/Aprovar Solicitações de Formação",
        },
      },
      {
        path: 'formacoes/aprovar-solicitacao-formacoes',
        name: 'Aprovar Solicitação de Formações',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-formacoes/ManterAprovacaoSolicitacaoView.vue'),
        meta: {
          title: 'Gerenciar Formações',
          breadcrumb: "Formações/Gerenciar Formações",
        },
      },
      {
        path: 'formacoes/consolidar-solicitacao-formacoes',
        name: 'Consolidar Formações',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-formacoes/MaterConsolidacaoSolicitacaoView.vue'),
        meta: {
          title: 'Consolidar Solicitação de Formação',
          breadcrumb: "Formações/Consolidar Solicitação de Formação",
        },
      },
      {
        path: 'formacoes/gerenciar-lista-presenca',
        name: 'Lista de Presença',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-lista-presenca/ManterListaPresencaView.vue'),
        meta: {
          title: 'Lista de Presença',
          breadcrumb: "Formações/Lista de Presença",
        },
      },
      {
        path: 'historico/gerenciar-historico-formacao',
        name: 'Gerenciar Histórico de Formação',
        component: () => import( /* webpackChunkName: "admin" */ 'views/post-login/administrador/manter-historico-de-formacao/ManterHistoricoDeFormacao.vue'),
        meta: {
          title: 'Gerenciar Histórico de Formação',
          breadcrumb: "Administrador/Gerenciar Histórico de Formação",
        },
      },
      {
        path: 'configurar/gerenciar-pagina-inicial',
        name: 'Gerenciar Página Inicial',
        component: () => import( /* webpackChunkName: "configuracao" */ 'views/post-login/base-configurations/CustomizeLandingPage.vue'),
        meta: {
          title: 'Gerenciar Página Inicial',
          breadcrumb: "Cadastro/Gerenciar Página Inicial",
        },
      },
      {
        path: 'configurar/perfis',
        name: 'configureprofiles',
        component: () => import( /* webpackChunkName: "configuracao" */ 'views/post-login/base-configurations/permissions/Profiles.vue'),
        meta: {
          title: 'Configurar Perfis'
        },
      },
      {
        path: 'organograma/gerenciar-organograma',
        name: 'Organograma',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-organograma/ManterOrganogramaView.vue'),
        meta: {
          title: 'Gerenciar Organograma',
          breadcrumb: "Administrador/Gerenciar Organograma",
        },
      },
      {
        path: 'organograma/detalhar-organograma/:id',
        name: 'Detalhar Organograma',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-organograma/DetalharOrganogramaView.vue'),
        meta: {
          title: 'Detalhar Organograma',
          breadcrumb: "Administrador/Detalhar Organograma",
        },
      },
      {
        path: 'periodo-formacao/gerenciar-periodo-formacao',
        name: 'Gerenciar Formação',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-periodo-formacao/ManterPeriodoFormacaoView.vue'),
        meta: {
          title: 'Gerenciar Período de Formação',
          breadcrumb: "Administrador/Gerenciar Período de Formação",
        },
      },
      {
        path: 'avaliacao-formacao/gerenciar-avaliacao-formacao',
        name: 'Avaliação de Formação',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-avaliacao-formacao/ManterAvaliacaoFormacaoView.vue'),
        meta: {
          title: 'Gerenciar Período de Formação',
          breadcrumb: "Formação/Gerenciar Avaliação de Formação",
        },
      },
      {
        path: 'materiais/gerenciar-materiais',
        name: 'Enviar Material',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-material/ManterMaterialView.vue'),
        meta: {
          title: 'Enviar Material',
          breadcrumb: "Materiais/Enviar Material",
        },
      },
      {
        path: 'materiais/banco-de-materiais',
        name: 'Banco de Materiais',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-banco-materiais-pelos-formadores/ManterBancoMateriaisPelosFormadoresView.vue'),
        meta: {
          title: 'Banco de Materiais',
          breadcrumb: "Materiais/Banco de Materiais",
        },
      },
      {
        path: 'formacoes/dashboard-formacao',
        name: 'Dashboards',
        component: () => import( /* webpackChunkName: "admin" */ '~/views/post-login/administrador/manter-dashboard-formacao/ManterDashboardFormacaoView.vue'),
        meta: {
          title: 'Dashboards',
          breadcrumb: "Formações/Dashboards",
        },
      },
      // Relatórios de Log 
      {
        path: "relatorio-log/manter-aba",
        name: "Relatório de Log de Aba",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-aba/RelatorioLogAba.vue"),
        meta: {
          title: "Relatório de Log de Aba",
          breadcrumb: "Relatório de Log de Aba",
        },
      },
      {
        path: "relatorio-log/manter-funcao",
        name: "Relatório de Log de Função",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-funcao/RelatorioLogFuncao.vue"),
        meta: {
          title: "Relatório de Log de Função",
          breadcrumb: "Relatório de Log de Função",
        },
      },
      {
        path: "relatorio-log/manter-perfil",
        name: "Relatório de Log de Perfil",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-perfil/RelatorioLogPerfil.vue"),
        meta: {
          title: "Relatório de Log de Perfil",
          breadcrumb: "Relatório de Log de Perfil",
        },
      },
      {
        path: "relatorio-log/manter-termo",
        name: "Relatório de Log de Termo",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-termo/RelatorioLogTermo.vue"),
        meta: {
          title: "Relatório de Log de Termo",
          breadcrumb: "Relatório de Log de Termo",
        },
      },
      {
        path: "relatorio-log/manter-usuario",
        name: "Relatório de Log de Usuário",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-usuario/RelatorioLogUsuario.vue"),
        meta: {
          title: "Relatório de Log de Usuário",
          breadcrumb: "Relatório de Log de Usuário",
        },
      },
      {
        path: "relatorio-log/manter-organograma",
        name: "Relatório de Log de Organograma",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-organograma/RelatorioLogOrganograma.vue"),
        meta: {
          title: "Relatório de Log de Organograma",
          breadcrumb: "Relatório de Log de Organograma",
        },
      },
      {
        path: "relatorio-log/manter-periodo-formacao",
        name: "Relatório de Log de Período Formação",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-periodo-formacao/RelatorioLogPeriodoFormacao.vue"),
        meta: {
          title: "Relatório de Log de Período Formação",
          breadcrumb: "Relatório de Log de Período Formação",
        },
      },
      {
        path: "relatorio-log/manter-setor",
        name: "Relatório de Log de Setor",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-setor/RelatorioLogSetor.vue"),
        meta: {
          title: "Relatório de Log de Setor",
          breadcrumb: "Relatório de Log de Setor",
        },
      },
      {
        path: "relatorio-log/manter-faq",
        name: "Relatório de Log de FAQ",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-faq/RelatorioLogFaq.vue"),
        meta: {
          title: "Relatório de Log de FAQ",
          breadcrumb: "Relatório de Log de FAQ",
        },
      },
      {
        path: "relatorio-log/manter-disciplina",
        name: "Relatório de Log de Disciplina",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-disciplina/RelatorioLogDisciplina.vue"),
        meta: {
          title: "Relatório de Log de Disciplina",
          breadcrumb: "Relatório de Log de Disciplina",
        },
      },
      {
        path: "relatorio-log/manter-solicitacao-formacao",
        name: "Relatório de Log de Solicitação de Formação",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-de-logs/manter-solicitacao-formacao/RelatorioLogSolicitacaoFormacao.vue"),
        meta: {
          title: "Relatório de Log de Solicitação de Formação",
          breadcrumb: "Relatório de Log de Solicitação de Formação",
        },
      },
      {
        path: "relatorio/solicitacao-formacao",
        name: "Relatório de Solicitação de Formação",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-formacao-solicitacao/RelatorioSinteticoAnaliticoFormacaoSolicitacao.vue"),
        meta: {
          title: "Relatório de Solicitação de Formação",
          breadcrumb: "Relatório de Solicitação de Formação",
        },
      },
      {
        path: "relatorio/formacao-escola",
        name: "Relatório de de Formação por Escola",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-formacao-solicitacao-escola/RelatorioSinteticoAnaliticoFormacaoPorEscolaSolicitacao.vue"),
        meta: {
          title: "Relatório de Formação por Escola",
          breadcrumb: "Relatório de Formação por Escola",
        },
      },
      {
        path: "relatorio/formacao-gre",
        name: "Relatório de de Formação por GRE",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-formacao-por-gre/RelatorioSinteticoAnaliticoFormacaoPorGre.vue"),
        meta: {
          title: "Relatório de Formação por GRE",
          breadcrumb: "Relatório de Formação por GRE",
        },
      },
      {
        path: "relatorio/formacao-disciplina",
        name: "Relatório de Formações por Disciplina",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-formacao-disciplina/RelatorioSinteticoAnaliticoFormacoesDisciplina.vue"),
        meta: {
          title: "Relatório de Formações por Disciplina",
          breadcrumb: "Relatório de Formações por Disciplina",
        },
      },
      {
        path: "relatorio/formacao-funcao",
        name: "Relatório de Formações por Função",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-formacao-funcao/RelatorioSinteticoAnaliticoFormacoesFuncao.vue"),
        meta: {
          title: "Relatório de Formações por Função",
          breadcrumb: "Relatório de Formações por Função",
        },
      },
      {
        path: "relatorio/formacao-publico-alvo",
        name: "Relatório de Formações por Público Alvo",
        component: () => import( /* webpackChunkName: "admin" */ "~/views/post-login/administrador/relatorios-sinteticos-analiticos/manter-publico-alvo/RelatorioSinteticoAnaliticoPublicoAlvo.vue"),
        meta: {
          title: "Relatório de Formações por Público Alvo",
          breadcrumb: "Relatório de Formações por Público Alvo",
        },
      },
    ],
  }
];
const routerFactory = (store) => {
  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: configurations.env.manutencao == "true" ? routesManutencao : routes,
  });

  const updateThemeAndBackground = (to) => {
    router.app.$isUserAdmin()
      ? router.app.$setThemeAdmin()
      : router.app.$setThemeProfissional();
    to.meta.showBackground
      ? router.app.showDefaultBackgroundImage()
      : router.app.hideDefaultBackgroundImage();
  }

  const updateTitleAndMetadata = (to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
    const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

    if (nearestWithTitle) {
      document.title = nearestWithTitle.meta.title;
    } else if (previousNearestWithMeta) {
      document.title = previousNearestWithMeta.meta.title;
    }

    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).forEach((el) =>
      el.parentNode.removeChild(el)
    );

    if (!nearestWithMeta) return next();

    nearestWithMeta.meta.metaTags
      .map((tagDef) => {
        const tag = document.createElement("meta");
        Object.keys(tagDef).forEach((key) => {
          tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute("data-vue-router-controlled", "");
        return tag;
      })
      .forEach((tag) => document.head.appendChild(tag));
  }
  const authorize = (to, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      const user = store.getters[`${AUTH_NAMESPACE}/${USER}`];

      if (user) {
        // 1. Aceite dos termos
        if (!user.acceptedTerms) {
          if (to.path !== '/consentimento-uso-de-dados-pessoais') {
            next({ path: '/consentimento-uso-de-dados-pessoais' });
          } else {
            next();
          }
          return;
        }

        // 2. Senha temporária
        if (user.changePassword) {
          if (to.path !== '/trocar-senha') {
            next({ path: '/trocar-senha' });
          } else {
            next();
          }
          return;
        }

        // 3. Primeiro acesso
        if (user.firstAccess) {
          if (to.path !== '/atualizacao-cadastral-primeiro-acesso') {
            next({ path: '/atualizacao-cadastral-primeiro-acesso' });
          } else {
            next();
          }
          return;
        }

        // 4. Acesso liberado
        next();
        return;
      }

      // Não autenticado
      next({ path: '/login' });
    } else {
      // Rota pública
      next();
    }
  };


  router.beforeEach((to, from, next) => {
    updateTitleAndMetadata(to, from, next);
    authorize(to, next);
  });

  router.afterEach((to) => {
    updateThemeAndBackground(to);
  });

  return router;
};

export default routerFactory;